import React, { useState, useEffect, useRef } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import SurveyExpired from './SurveyExpired';
import "../css/upcomingSurveyTimer.css"
const UpcominSurveyTimer = ({startingDate}) => {
  const [timeLeft, setTimeLeft] = useState({
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  
  const [showExpired, setShowExpired] = useState(false);
  const prevTimeRef = useRef({...timeLeft});
  const [animatingValues, setAnimatingValues] = useState({
    years: false,
    months: false,
    days: false,
    hours: false,
    minutes: false,
    seconds: false
  });

  useEffect(() => {
    // Set the target date to May 22, 2026, 10:16:12
    const targetDate = new Date(startingDate);
    
    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = targetDate - now;
      
      if (difference <= 0) {
        setShowExpired(true);
        return {
          years: 0,
          months: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      
      // Calculate time units
      const years = Math.floor(difference / (1000 * 60 * 60 * 24 * 365));
      const months = Math.floor((difference % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
      const days = Math.floor((difference % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      return {
        years,
        months,
        days,
        hours,
        minutes,
        seconds
      };
    };
    
    // Update the countdown every second
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      
      // Check which values have changed and set animation flags
      const newAnimatingValues = {...animatingValues};
      Object.keys(newTimeLeft).forEach(key => {
        if (newTimeLeft[key] !== prevTimeRef.current[key]) {
          newAnimatingValues[key] = true;
          
          // Reset animation after it completes
          setTimeout(() => {
            setAnimatingValues(prev => ({
              ...prev,
              [key]: false
            }));
          }, 300);
        }
      });
      
      setAnimatingValues(newAnimatingValues);
      prevTimeRef.current = {...newTimeLeft};
      setTimeLeft(newTimeLeft);
    }, 1000);
    
    // Initial calculation
    const initialTimeLeft = calculateTimeLeft();
    setTimeLeft(initialTimeLeft);
    prevTimeRef.current = {...initialTimeLeft};
    
    // Cleanup on unmount
    return () => clearInterval(timer);
  }, []);
  
  
  if (showExpired) {
    return <SurveyExpired />;
  }
  
  return (
    <div className="countdown-container">
      <div className="countdown-card">
        <h1 className="countdown-title">Survey will live in...</h1>
        <div className="countdown-timer">
          {timeLeft.years>0 && <div className="time-block" style={{"--i": 0}}>
            <div className={`time-value ${animatingValues.years ? 'changed' : ''}`}>{timeLeft.years}</div>
            <div className="time-label">Years</div>
          </div>}
          {timeLeft.months>0 && <div className="time-block" style={{"--i": 1}}>
            <div className={`time-value ${animatingValues.months ? 'changed' : ''}`}>{timeLeft.months}</div>
            <div className="time-label">Months</div>
          </div>}
          {timeLeft.days>0 && <div className="time-block" style={{"--i": 2}}>
            <div className={`time-value ${animatingValues.days ? 'changed' : ''}`}>{timeLeft.days}</div>
            <div className="time-label">Days</div>
          </div>}
          {timeLeft.hours>0 && <div className="time-block" style={{"--i": 3}}>
            <div className={`time-value ${animatingValues.hours ? 'changed' : ''}`}>{timeLeft.hours}</div>
            <div className="time-label">Hours</div>
          </div>}
          {timeLeft.minutes>0 && <div className="time-block" style={{"--i": 4}}>
            <div className={`time-value ${animatingValues.minutes ? 'changed' : ''}`}>{timeLeft.minutes}</div>
            <div className="time-label">Minutes</div>
          </div>}
          <div className="time-block" style={{"--i": 5}}>
            <div className={`time-value ${animatingValues.seconds ? 'changed' : ''}`}>{timeLeft.seconds}</div>
            <div className="time-label">Seconds</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcominSurveyTimer;
